'use client';

import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  Typography,
  Link as MuiLink,
  CircularProgress,
  useTheme,
} from '@mui/material';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { ResponseErrorPanel } from '@backstage/core-components';

export default function PrivacyDialog() {
  const theme = useTheme();
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const discoveryApi = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);

  const handleSubmit = async () => {
    if (privacyChecked && termsChecked) {
      try {
        const base_url = await discoveryApi.getBaseUrl('blackpearl');
        const response = await fetch(`${base_url}/toc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (response.status !== 204) {
          throw new Error('toc acceptance failure');
        }

        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const { value, loading, error } = useAsync(async (): Promise<boolean> => {
    const base_url = await discoveryApi.getBaseUrl('blackpearl');
    const response = await fetch(`${base_url}/user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const toc = await response.json();
    return toc!.toc_accepted;
  }, []);

  if (loading) {
    return <CircularProgress />;
  } else if (error) {
    return <ResponseErrorPanel error={error} />;
  }
  return (
    <Dialog open={!value!}>
      <DialogContent
        style={{
          maxWidth: 600,
          backgroundColor: '#373745',
          border: 'none',
          padding: 24,
        }}
      >
        <h1
          style={{
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '150%',
            paddingBottom: '15px'
          }}
        >
          Privacy Policy & Terms and Conditions
        </h1>
        <Box
          style={{ marginTop: 2, display: 'grid', gap: 2, color: theme.palette.text.primary }}
        >
          <Typography
            style={{
              color: theme.palette.text.primary,
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '150%',
              paddingBottom: '15px'
            }}
          >
            Before proceeding, please take a moment to review our Privacy Policy
            and accept our Terms & Conditions.
          </Typography>

          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={privacyChecked}
                  onChange={e => setPrivacyChecked(e.target.checked)}
                  style={{ color: '#9894F9' }}
                />
              }
              label={
                <Typography variant="body2" style={{ color: '#ffffff', fontSize: '14px' }}>
                  I agree with the{' '}
                  <MuiLink
                    href="https://www.deepc.ai/privacy"
                    underline="hover"
                    style={{ color: '#BAB7FB' }}
                  >
                    Privacy Policy
                  </MuiLink>
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={termsChecked}
                  onChange={e => setTermsChecked(e.target.checked)}
                  style={{ color: '#8A87E3' }}
                />
              }
              label={
                <Typography variant="body2" style={{ color: '#ffffff', fontSize: '14px' }}>
                  I have read and accept the{' '}
                  <MuiLink
                    href="https://www.deepc.ai/documents/terms-conditions-for-use-of-deepcos-hub"
                    underline="hover"
                    style={{ color: '#BAB7FB' }}
                  >
                    Terms & Conditions (T&C), Data Processing Agreement (DPA) and the Technical and Organizational Measures (TOM)
                  </MuiLink>
                </Typography>
              }
            />
          </Box>

          <Typography
            style={{
              marginTop: 10,
              marginBottom: 10,
              color: theme.palette.text.primary,
              fontFamily: 'Inter',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '150%',
              paddingTop: '15px',
              paddingBottom: '15px'
            }}
          >
            By clicking submit, I acknowledge that the Software is not intended
            to be used and MUST not be used for medical, diagnostic, or business
            purposes.
          </Typography>
          <Box style={{ display: 'flex', justifyContent: 'right' }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: !privacyChecked || !termsChecked ? '#9894F91F' : '#8A87E3', width: 120, color: !privacyChecked || !termsChecked ? '#FFFFFF61' : "#ffffff"
              }}
              onClick={handleSubmit}
              disabled={!privacyChecked || !termsChecked}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
